import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddVenueLayer from "../components/AddVenueLayer";

const AddVenuePage = () => {
    return (
        <MasterLayout>
            <Breadcrumb title="Add New Venue" />
            <AddVenueLayer />
        </MasterLayout>
    );
};

export default AddVenuePage;
